export const ARVUT_SYSTEM_URL = "https://arvut.kli.one";
export const ARCHIVE_LINK = "https://kabbalahmedia.info";
export const PAY_KLI_ONE_URL = "https://pay.kli.one/";
export const BB_CONVENTION_REGISTERED = "bbe_reg";
export const BB_CONVENTION_REGISTER_LINK = "https://kli.one/register/";
export const BB_CONVENTION_REGISTER_SITE = "https://convention.kli.one/";
export const BB_HELP_LINK = "/help";
